import { render } from "./IconComponent.vue?vue&type=template&id=4fb317d0&scoped=true"
import script from "./IconComponent.vue?vue&type=script&lang=js"
export * from "./IconComponent.vue?vue&type=script&lang=js"

import "./IconComponent.vue?vue&type=style&index=0&id=4fb317d0&scoped=true&lang=css"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb317d0"]])

export default __exports__